var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimplestimateLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 26,
    viewBox: "0 0 38 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3904_30462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32C34.5 0 38 3.80144 38 8.48205V26L6.5 26C4.5 26 0 22.1986 0 17.5179V0Z",
    fill: "#FE6A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.887 15.3008C10.887 15.3008 12.0192 16.7227 13.8019 16.7227C14.6932 16.7227 15.4626 16.3178 15.4626 15.5048C15.4626 13.7565 10.2397 13.9605 10.2397 10.8719C10.2397 9.04203 11.8597 8.19141 13.8019 8.19141C14.9747 8.19141 16.9607 8.59629 16.9607 10.0621V10.9567H15.3V10.4702C15.3 9.90204 14.4493 9.65722 13.8425 9.65722C12.7479 9.65722 12.0599 10.0244 12.0599 10.7935C12.0599 12.6234 17.2828 12.2153 17.2828 15.4263C17.2828 17.1339 15.7847 18.2293 13.7612 18.2293C11.2092 18.2293 9.95508 16.5218 9.95508 16.5218L10.887 15.3039V15.3008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7796 8C26.4502 8 27.9079 10.0308 27.9079 12.5105C27.9079 12.7553 27.867 13.2826 27.867 13.2826H20.9023C21.0244 15.3134 22.4815 16.4936 24.1828 16.4936C25.8841 16.4936 26.9755 15.3574 26.9755 15.3574L27.7858 16.6568C27.7858 16.6568 26.369 18.0788 24.1016 18.0788C21.0647 18.0788 19.0006 15.8847 19.0006 13.041C18.9602 9.95236 21.0647 8.00315 23.7796 8.00315V8ZM26.0062 11.9016C25.9658 10.3165 24.9522 9.46272 23.7387 9.46272C22.3219 9.46272 21.1868 10.3165 20.9051 11.9016H26.0062Z",
    fill: "#0B1A36"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3904_30462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplestimateLogo);
export default __webpack_public_path__ + "static/media/simplestimate-logo.c5e3453e25efeb7ba0f7837acc681ff2.svg";
export { ForwardRef as ReactComponent };